@if (!listLoading()) {
  <div class="w-100 ap-mb-spacing-5">
    <gstar-combobox
      [required]="required()"
      [label]="
        placeholder() || ('admin.dashboard.entityTypesTitle' | translate)
      "
      [options]="entityTypes()"
      keyProp="name"
      valueProp="entityTypeId"
      trackByKey="entityTypeId"
      [value]="value"
      [disabled]="disabled()"
      (selectItem)="selectEntityTypeHandler($event)"
      (clearValue)="clearTargetEntityType()" />
  </div>
}
